<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="text-indent:0px;"><strong>Photo Credits and Graphic Design</strong></p>
<br/>
<p style="text-indent:0px;">Melanie Gillis Photography, Hamilton, Ontario, Canada</p>
<br/>
<p style="text-indent:0px;">Paul Wallace, Orangeville, Ontario, Canada</p>
<br/>
<p style="text-indent:0px;">F-Stop Foto and Frame, Orangeville, Ontario, Canada</p>
<br/>
<p style="text-indent:0px;"><strong>Contributors</strong></p>
<br/>
<p style="text-indent:0px;">Carl Capuano and the Rise Again Band, Geoff Saxon, Jeff Belrose, Lynne Mellor, Joffrey Bernabe, Jennifer Millett, Jessica Buscher and Rosanna Camposarcone Airhardt.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?2bba7da3